import React from 'react';

const AppearanceContext = React.createContext({
  isLoading: false,
  isSubmitLoading: false,
});

export default AppearanceContext;
